import { useEffect } from 'react';
import { BRAND_NAME } from '../constants/Branding';

const Sitemap = () => {
  useEffect(() => {
    // Check if brand is ShivShaktiGaming
    if (BRAND_NAME?.toLowerCase() !== 'shivshaktigaming') {
      // Return 404 for non-ShivShaktiGaming brands
      return;
    }

    const sitemapContent = `<?xml version="1.0" encoding="UTF-8"?>
<urlset xmlns="http://www.sitemaps.org/sche mas/sitemap/0.9">
 
  <url>
<loc>https://shivshaktigaming.com/</loc>
<lastmod>2026-01-23</lastmod>
<priority>1.00</priority>
</url>
 
</urlset>`;

    // Set content type meta tag
    const meta = document.querySelector('meta[http-equiv="Content-Type"]');
    if (meta) {
      meta.setAttribute('content', 'application/xml; charset=UTF-8');
    } else {
      const newMeta = document.createElement('meta');
      newMeta.httpEquiv = 'Content-Type';
      newMeta.content = 'application/xml; charset=UTF-8';
      document.head.appendChild(newMeta);
    }
  }, []);

  // Only render XML if brand is ShivShaktiGaming
  if (BRAND_NAME?.toLowerCase() !== 'shivshaktigaming') {
    return (
      <div style={{ padding: '20px', textAlign: 'center' }}>
        <h1>404 - Not Found</h1>
        <p>The requested resource was not found.</p>
      </div>
    );
  }

  const sitemapContent = `<?xml version="1.0" encoding="UTF-8"?>
<urlset xmlns="http://www.sitemaps.org/schemas/sitemap/0.9">
 
  <url>
<loc>https://shivshaktigaming.com/</loc>
<lastmod>2026-01-23</lastmod>
<priority>1.00</priority>
</url>
 
</urlset>`;

  return (
    <pre style={{ 
      whiteSpace: 'pre-wrap', 
      margin: 0, 
      padding: '20px',
      fontFamily: 'monospace',
      fontSize: '14px'
    }}>
      {sitemapContent}
    </pre>
  );
};

export default Sitemap;